// extracted by mini-css-extract-plugin
export default {"container":"VerifySnackbar_container__k-Bv9","error":"VerifySnackbar_error__6q4lv","info":"VerifySnackbar_info__xM+aR","verifyBtn":"VerifySnackbar_verifyBtn__c-LfC"};